module.exports = __webpack_public_path__ + "static/media/miniiks.279ba7e6.svg";